// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1BhYx","noInteraction":"EventWrapper_noInteraction__37DXK"};